import { findIndex } from "lodash";

import { FieldRequestTypeEnum } from "@krea/shared/types/fieldRequest";

import {
  FieldRequestFieldEnum,
  type IFieldRequest,
} from "../types/fieldRequest";

export const getFilteredFieldRequests = (
  fieldsToFilter: string[] = [],
  fieldRequests: IFieldRequest[] = [],
) => {
  const result: IFieldRequest[] = [];

  fieldsToFilter.forEach((field) =>
    fieldRequests.forEach((item) => {
      if ((item.field as string) === field) {
        result.push(item);
      }
    }),
  );

  return result;
};

export const getNextRequest = (
  triageFields: string[],
  fieldRequests: IFieldRequest[],
  field: FieldRequestFieldEnum,
) => {
  const triageFieldsResult = triageFields.length
    ? getFilteredFieldRequests(triageFields, fieldRequests)
    : fieldRequests;

  const stepIndex = findIndex(
    triageFieldsResult,
    (request) => request.field === field,
  );
  const nextStep =
    stepIndex !== triageFieldsResult.length - 1 ? stepIndex + 1 : null;

  return nextStep ? triageFieldsResult[nextStep] : undefined;
};

export const getPreviousRequest = (
  triageFields: string[],
  fieldRequests: IFieldRequest[],
  field: FieldRequestFieldEnum,
) => {
  const triageFieldsResult = triageFields.length
    ? getFilteredFieldRequests(triageFields, fieldRequests)
    : fieldRequests;

  const stepIndex = findIndex(
    triageFieldsResult,
    (request) => request.field === field,
  );
  const previousStep = stepIndex !== 0 ? stepIndex - 1 : null;

  return previousStep != null ? triageFieldsResult[previousStep] : undefined;
};

export const hasFieldRequestsToUpdate = (
  fieldRequests: IFieldRequest[],
  shouldConsiderLenderComment: boolean,
) => {
  // return true if there is at least one field request to update
  // =======
  // If changes are made here, also look on the backend, to check that the logic for LenderResponse.unsubmittedFieldRequests is the same
  // (not taking the lenderComment into account, which is fine).
  return (
    fieldRequests.filter(
      ({ lenderComment, isCollectedByLender, isSubmitted, field, type }) => {
        if (
          type === FieldRequestTypeEnum.COLLATERAL &&
          field !== FieldRequestFieldEnum.guarantors
        ) {
          return false; // don't consider collateral field requests (with the exception of guarantors)
        }
        // If the field request is collected by lender, we don't want to consider it
        if (isCollectedByLender) return false;

        if (isSubmitted) {
          if (shouldConsiderLenderComment) {
            // only consider a submitted FR if there is a lenderComment and we want to consider it
            if (lenderComment) {
              return true;
            }
            return false;
          }
          // submitted FRs will not be considered if we don't want to consider lenderComment
          return false;
        }
        // unsubmitted FRs will be considered if they are not collected by lender
        return true;
      },
    ).length > 0
  );
};
